export const SET_ACTIVE_TOUR = 'SET_ACTIVE_TOUR';
export const SET_HELP_HERO = 'SET_HELP_HERO';
export const RESET_ALL_ACTIVE_TOURS = 'RESET_ALL_ACTIVE_TOURS';
